// Generated by ReScript, PLEASE EDIT WITH CARE


function sanitize(value) {
  return value.replace(/\s/g, "");
}

function isValidSiren(value) {
  if (value.length === 9) {
    return /^[0-9]+$/.test(value);
  } else {
    return false;
  }
}

function isValidSiret(value) {
  if (value.length === 14) {
    return /^[0-9]+$/.test(value);
  } else {
    return false;
  }
}

function sirenFromSiret(siret) {
  return siret.slice(0, 9);
}

function registryUrl(siret) {
  return "https://annuaire-entreprises.data.gouv.fr/etablissement/" + siret;
}

function format(value) {
  let digits = sanitize(value);
  let match = /^[0-9]+$/.test(digits) ? digits.length : 0;
  if (match !== 9 && match !== 14) {
    return value;
  }
  return [
    digits.slice(0, 3),
    digits.slice(3, 6),
    digits.slice(6, 9),
    digits.slice(9)
  ].filter(group => group !== "").join(" ");
}

let French = {
  isValidSiren: isValidSiren,
  isValidSiret: isValidSiret,
  sirenFromSiret: sirenFromSiret,
  registryUrl: registryUrl,
  format: format
};

function normalize(value) {
  return sanitize(value).toUpperCase();
}

function isValid(value) {
  return /^[A-Z]{2}[0-9A-Z]{2,12}$/.test(sanitize(value).toUpperCase());
}

function countryCode(value) {
  let normalized = sanitize(value).toUpperCase();
  if (isValid(normalized)) {
    return normalized.slice(0, 2);
  }
}

let Vat = {
  normalize: normalize,
  isValid: isValid,
  countryCode: countryCode
};

function isValidBce(value) {
  if (value.length === 10) {
    return /^[0-9]+$/.test(value);
  } else {
    return false;
  }
}

function isValidVatNumber(value) {
  return /^BE[0-9]{10}$/.test(sanitize(value).toUpperCase());
}

function bceFromVatNumber(value) {
  return sanitize(value).toUpperCase().replace(/^BE/, "");
}

let Belgian = {
  isValidBce: isValidBce,
  isValidVatNumber: isValidVatNumber,
  bceFromVatNumber: bceFromVatNumber
};

export {
  French,
  Vat,
  Belgian,
}
/* No side effect */
